import { initialState } from "./state"

export default {
  resetCore: state => {
    const INITIAL_STATE = initialState()
    Object.keys(state).forEach(key => {
      state[key] = INITIAL_STATE[key]
    })
  }
}
